export interface CredentialOffer {
    templateId: string;   // used in POST /manage/vc/{templateId}
    title: string;
    description: string;
    imageUrl: string;
}

export const credentialOffers: CredentialOffer[] = [
    {
        templateId: 'pid',
        title: 'Personal ID',
        description: 'Your government-issued digital identity (PID).',
        imageUrl: 'https://demopidprovider.acc.credenco.com/rijkskaart.png',
    },
    {
        templateId: 'rijbewijs',
        title: 'Rijbewijs',
        description: "Your Dutch driver's license",
        imageUrl: 'https://demopidprovider.acc.credenco.com/dutch-driving-licence.png',
    },
    {
        templateId: 'iban',
        title: 'IBAN',
        description: 'Your verified bank account number.',
        imageUrl: 'https://tulip-bank.acc.credenco.com/card_background.jpg',
    },
];
